import React from "react";
import { GetCorServicei } from "./../_getjson";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import PopUpSelSaleRef3Sub from "./PopUpSelSaleRef3Sub";
import { parseJwt } from "../parseJWT";
import { genURL } from "./../_getjson";
import axios from 'axios'
import FullScreenDialog from '../PopUp/FullScreendialogs/FullScreen'
require("./../_css/PopUpOther.css");
/* const rowTable = 15; */
export default class PopUpOther extends React.Component {

  constructor(props) {
    super(props);
    this.P_DOCNO = React.createRef();
    this.Search = React.createRef();
    this.state = {
      SelSaleRef3Sub: false,
      type: this.props.type,
      col: [],
      rows: [],
      Htext: "",
      SHtype: 3,
      P_DOCNO: "",
      casschkbox: "far fa-square",
      casschkboxs: false,
      ckbox_length: 0,
    };
  };
  chkdata = (data) => {
    var redata = "";
    if (data) {
      redata = data !== "" ? data : typeof data !== undefined ? data : "";
    }
    return redata;
  };
  //--------------------------------โชว์ PopUpARPaybillsub
  SetPopup3 = (data) => {
    this.setState({ PopUpTYpe5: data });
    this.setState({ SelSaleRef3Sub: !this.state.SelSaleRef3Sub });
  };

  //รับค่าหน้า sub แล้วส่งค่ากลับหน้าหลัก
  Get_PopUpSelSaleRef3Sub = (data) => {
    this.CloseDialog(false)
    let redata = ""
    console.log("Get_PopUpSelSaleRef3Sub", data);
    for (var i = 0; i < data.length; i++) {
      redata =
        this.chkdata(data[i].Col1) +//0
        "|" +
        this.chkdata(data[i].Col2) +//1
        "|" +
        this.chkdata(data[i].Col3) +//2
        "|" +
        this.chkdata(data[i].Col4) +//3
        "|" +
        this.chkdata(data[i].Col5) +//4
        "|" +
        this.chkdata(data[i].Col6) +//5
        "|" +
        this.chkdata(data[i].Col7) +//6
        "|" +
        this.chkdata(data[i].Col8) +//7
        "|" +
        this.chkdata(data[i].Col9) +//8
        "|" +
        this.chkdata(data[i].Col10) +//9
        "|" +
        this.chkdata(data[i].Col11) +//10
        "|" +
        this.chkdata(data[i].Col12) +//11
        "|" +
        this.chkdata(data[i].Col13) +//12
        "|" +
        this.chkdata(data[i].Col14) +//13
        "|" +
        data[i]._unitCode +//14
        "|" +
        this.chkdata(data[i]._refLineID) +//15
        "|" +
        data[i].maingroup +//16
        "|" +
        data[i].STOCKTYPE +//17
        "|" +
        data[i].ITEMTAXTYPE +//18
        "|" +
        data[i].productset //19  

      this.props.Get_SelSaleRef3(redata, this.state.taxtype, this.state.creditcode, this.state.department, this.state.sitecode, this.state.salecode, this.state.reftaxtype);
      // console.log("redata");
      // console.log(redata);
    }
    // this.props.Get_SelSaleRef3(redata, this.state.taxtype, this.state.creditcode, this.state.department, this.state.sitecode, this.state.salecode);

    // this.setState({ SelSaleRef3Sub: !this.state.SelSaleRef3Sub });
  };

  // รีเฟรช table1 
  onClickRefresh = () => {
    this.componentDidMount();
  };
  //กดค้นหา
  Get_Data = (event) => {
    console.log("Get_Data", event)
    var dataArray = [];
    var Url = "";
    var DOCNO = "";
    if (event == "searchData") {
      console.log("Get_Data this.Search.current.value", this.Search.current.value)
      Url = genURL("CSV_SALEREFDOCNO3/getsearchmaindoc?arcode=" + this.props.ARCODE.trim() + "&txtSearch=" + this.Search.current.value)
    } else {
      return; //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
    }
    axios.get(Url).then((res) => {
      console.log("Get_Data", res)
      if (res.data.length >= 1) {
        var j = 0;
        for (let i = 0; i < res.data.length; i++) {

          dataArray[j] = {
            number: i + 1,
            Col1: res.data[i].DOCNO,
            Col2: this.GetformatTimestamp(res.data[i].DOCDATE),
            Col3: this.GetformatTimestamp(res.data[i].DUEDATE),
            Col4: res.data[i].SALENAME,
            Col5: res.data[i].CREDITCODE,
            Col6: res.data[i].REMARK,
            Col7: res.data[i].DEBTAMOUNT,
            Col8: res.data[i].TYPE,
            SB: "0",
            department: res.data[i].DEPARTMENT,
            sitecode: res.data[i].SITECODE,
            salecode: res.data[i].SALECODE,
            productsetcode: res.data[i].PRODUCTSETCODE,
            taxtype: res.data[i].TAXTYPE
            // this.setState({ taxtype: res.data[i].TAXTYPE });
          };
          j++
        }
        this.setState({ col: dataArray });
        this.GetSearchTimeout();
      } else {
        dataArray = [];
        this.setState({ col: dataArray });
        this.GetSearchTimeout();
      }
    });
  };

  GetSearchTimeout = () => {
    this.setState({ rows: this.state.col });
  };
  GetformatTimestamp = (date) => {
    if (date) {
      var myDate = new Date(date);
      var date = myDate.getDate();
      if (myDate.getDate() < 10) {
        date = "0" + myDate.getDate();
      }
      var month = myDate.getMonth() + 1;
      if (myDate.getMonth() + 1 < 10) {
        month = "0" + (myDate.getMonth() + 1);
      }
      var year = myDate.getFullYear() + 543;
      return date + "/" + month + "/" + year;
    } else {
      return "";
    }
  };
  componentDidMount() {
    //โหลดหน้าครั้งแรกเรียก API โชว์ข้อมูล
    /* this.setRow(rowTable); */
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    setTimeout(() => {
      var dataArray = this.state.rows;
      switch (this.props.type) {
        case "SelSaleRef3":
          this.setState({ sh_Deposit: true });
          var Url = "CSV_SALEREFDOCNO3/getdocno?arcode=" + this.props.ARCODE.trim() + "&docno=";
          // console.log("urlCSV_SALEREFDOCNO3 ", genURL(Url));
          axios.get(genURL(Url)).then((res) => {
            var j = 0;
            if (res.data.length >= 1) {
              for (let i = 0; i < res.data.length; i++) {
                //   if(res.data[i].SITECODE==SITECODESTR.User.SITECODE){
                dataArray[j] = {
                  number: i + 1,
                  Col1: res.data[i].DOCNO,
                  Col2: this.GetformatTimestamp(res.data[i].DOCDATE),
                  Col3: this.GetformatTimestamp(res.data[i].DUEDATE),
                  Col4: res.data[i].SALENAME,
                  Col5: res.data[i].CREDITCODE,
                  Col6: res.data[i].REMARK,
                  Col7: res.data[i].DEBTAMOUNT,
                  Col8: res.data[i].TYPE,
                  SB: "0",
                  department: res.data[i].DEPARTMENT,
                  sitecode: res.data[i].SITECODE,
                  salecode: res.data[i].SALECODE,
                  productsetcode: res.data[i].PRODUCTSETCODE,
                  taxtype: res.data[i].TAXTYPE
                  // this.setState({ taxtype: res.data[i].TAXTYPE });
                };
                j++;
                //   }

              }
              this.setState({ col: dataArray });
              this.GetSearchTimeout();
            } else {
              dataArray = [];
              this.setState({ col: dataArray });
              this.GetSearchTimeout();
            }
          });
          this.setState({ col: dataArray, Htext: "ค้นหาเอกสารอ้างอิงขาย" });
          break;
      }
    }, 200);
  }
  /* setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ rows: data });
  }; */
  //onClick checkbox
  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.rows[rowIndex].SB;
    var btnShow;
    switch (btn) {
      case "0":
        btnShow = (
          <span>
            <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")} > </i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")} ></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span><i class=""></i> </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  //เปลี่ยนสถานะ checkbox
  Update_Status = (Row, Status) => {
    if (Status === "ALL") {
      if (this.state.casschkboxs === false) {
        //กด checkbox เลือกทั้งหมด
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });
        var dataArray = this.state.rows;
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
          dataArray[i].SB = "1";
        }
        this.setState({ row: dataArray });
      } else {
        //กด checkbox ไม่เลือก
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });
        var dataArray = this.state.rows;
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
          dataArray[i].SB = "0";
        }
        this.setState({ row: dataArray });
      }
    } else {
      //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
      if (Status === "0") {
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: false });
      }
      //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
      var dataArray = this.state.rows;
      dataArray[Row].SB = Status;
      this.setState({ rows: dataArray });
      //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
      var sb_length = 0;
      console.log(this.state.rows.length);
      for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
        if (this.state.rows[i].SB === "1") {
          sb_length = sb_length + 1;
        }
      }
      if (sb_length === this.state.rows.length) {
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: true });
      }
    }
  };
  onSelectRow = (data, col, id, cellValue) => {
    //ส่งกลับเมื่อมีการคลิกเลือกข้อมูล
    if (col > 1 && data.Col1) {
      var dataArray = this.state.rows;
      dataArray[id].SB = "1";
      this.setState({ rows: dataArray });

      // console.log("rowsonSelectRow", this.state.rows);
      var sb_length = 0;
      var docno = "";
      for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
        if (this.state.rows[i].SB === "1") {
          sb_length = sb_length + 1;
          docno = docno + "&docno=" + this.state.rows[i].Col1;
          this.setState({ creditcode: this.state.rows[i].Col5 });
          this.setState({ department: this.state.rows[i].department });
          this.setState({ sitecode: this.state.rows[i].sitecode });
          this.setState({ salecode: this.state.rows[i].salecode });
          this.setState({ reftaxtype: this.state.rows[i].taxtype });

        }
      }
      this.P_DOCNO.current.value = docno;

      //  this.setState({ taxtype: this.state.rows[i].taxtype });



      setTimeout(() => {
        this.setState({ PopUpTYpe5: data });
        // this.setState({ SelSaleRef3Sub: !this.state.SelSaleRef3Sub });
        //ชื่อ
        this.setState({ typeFullScreenDialog: "SelSaleRef3" })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "เลือกรายการย่อย" })
      }, 200);
    }
  };
  onSubmit = () => {
    var docno = "";
    var sb_length = 0;
    for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
      if (this.state.rows[i].SB === "1") {
        sb_length = sb_length + 1;
        docno = docno + "&docno=" + this.state.rows[i].Col1;
        this.setState({ creditcode: this.state.rows[i].Col5 });
        this.setState({ department: this.state.rows[i].department });
        this.setState({ sitecode: this.state.rows[i].sitecode });
        this.setState({ salecode: this.state.rows[i].salecode });
        this.setState({ reftaxtype: this.state.rows[i].taxtype });
      }
    }
    this.P_DOCNO.current.value = docno;
    if (docno !== "") {
      setTimeout(() => {
        // this.setState({ SelSaleRef3Sub: !this.state.SelSaleRef3Sub });
        //ชื่อ
        this.setState({ typeFullScreenDialog: "SelSaleRef3" })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "เลือกรายการย่อย" })
      }, 0);
    }
  };
  /* _chkload = (cell, row, enumObject, rowIndex) => {
    return (<div><i id={"load" + rowIndex}>{rowIndex + 1}</i></div>);
  }; */
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e })
  }
  onKeyDown = (e) => {
    console.log("onKeyDown", e.target.value);
    if (e.key === "Enter") {
      this.Get_Data('searchData')
    }
  }
  render() {
    return (
      <div className="popup" style={{ "z-index": "100" }}>
        <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
          {this.state.typeFullScreenDialog === "SelSaleRef3" ? <PopUpSelSaleRef3Sub closePopup={() => this.CloseDialog(false)} Get_PopUpSelSaleRef3Sub={this.Get_PopUpSelSaleRef3Sub} type={this.state.PopUpTYpe5} Data={this.state.valuePopup5} ARCODE={this.props.ARCODE} P_DOCNO={this.P_DOCNO.current.value} from="PopUpSelSaleRef3" /> : null}
        </FullScreenDialog>
        <div className="popup_inner">
          {this.props.Data}
          <div class="PopUpOtherDivH" align="left">
            <div class="PopUpOtherDivH1">
              <i class="fas fa-search"> ค้นหาเอกสารอ้างอิงขาย-SelSelRef3{/* {this.state.TxtTitle}  */}</i>
            </div>
            <div class="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i class="fas fa-times"></i>
            </div>
          </div>
          <div class="panel-body divTable" align="left">
            <input type="hidden" class="form-control " ref={this.P_DOCNO} />
            <div class="input-group width-grop">
              <input type="text" class="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyDown={this.onKeyDown} ref={this.Search} />
              <span class="input-group-addon txt-img icon">
                <i class="fas fa-search" onClick={this.Get_Data.bind(null, "searchData")}></i>
              </span>
              <span class="input-group-addon txt-img icon">
                <i class="fas fa-sync-alt" onClick={this.onClickRefresh}></i>
              </span>
            </div>


            <div style={{ marginTop: "10px" }} >
              <BootstrapTable
                data={this.state.rows}
                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา", }}
                height="520"
                hover condensed /* search */>
                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="20" dataField="number" isKey /* dataFormat={this._chkload.bind(this)} */></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15" dataField="SB" dataAlign="center" editable={false} dataFormat={this.cellcheckbok.bind(this)}><div onClick={this.Update_Status.bind(null, "", "ALL")}>  <i style={{ fontSize: "20" }} class={this.state.casschkbox}></i></div></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="Col1" dataSort={true}>เลขที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40" dataField="Col2" dataSort={true}>วันที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40" dataField="Col3" dataSort={true}>ลงวันที่</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40" dataField="Col4">พนักงานขาย</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40" dataField="Col5">รหัสเครดิต</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="Col6">หมายเหตุ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30" dataField="Col7" >จำนวนเงินทั้งสิ้น</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30" dataField="Col8">ประเภท</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="department" hidden>department</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="productsetcode" hidden>productsetcode</TableHeaderColumn>
                <TableHeaderColumn dataField="sitecode" hidden></TableHeaderColumn>
                <TableHeaderColumn dataField="salecode" hidden></TableHeaderColumn>
                <TableHeaderColumn dataField="taxtype" hidden></TableHeaderColumn>
              </BootstrapTable>
            </div>
            <button class="PUSDbtn" style={{ float: 'right' }} onClick={this.onSubmit}>
              <i class="fas fa-check"> ตกลง </i>
            </button>
          </div>
        </div>
      </div >
    );
  }
}
